/** Water tariff plans /metering/fee/water-plan (waterPlan.vue) */
export default {
  waterPlanPage: {
    sectionTitle: 'Water plans',
    btnAddPlan: 'New plan',
    emptyTable: 'No water plans yet',
    emptyNoPermission: 'No permission to view',
    colPlanId: 'Plan ID',
    colPlanName: 'Plan name',
    colPrice: 'Price (¥/t)',
    colUpdated: 'Updated',
    colAction: 'Actions',
    btnAdjust: 'Adjust',
    btnBatchBind: 'Batch assign',
    modalTitleEdit: 'Adjust price',
    modalTitleAdd: 'New plan',
    formPlanName: 'Plan name',
    phPlanName: 'Enter plan name',
    labelWaterPrice: 'Water price',
    unitPerTon: '¥/t',
    warnEditNote: 'Note: saving will update billing for linked water meters.',
    labelPhoneBound: 'Phone',
    labelVerifyCode: 'SMS code',
    phVerifyCode: 'Enter code',
    sendCode: 'Send code',
    resendIn: 'Resend in {n}s',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    drawerTitle: 'Batch assign meters',
    tabPrivate: 'Dedicated',
    tabShare: 'Shared',
    tabFormula: 'Formula',
    phSearchMeter: 'Search meter name',
    selectAll: 'Select all',
    tagShareGroup: 'Shared group',
    tagBound: 'Assigned',
    emptyTreeNoMatch: 'No matching meters',
    emptyTreeNoData: 'No meters',
    selectedWaters: '{count} meter(s) selected',
    btnConfirmBind: 'Assign',
    msgLoadFail: 'Failed to load data',
    msgNoOperate: 'No permission',
    msgSmsSent: 'Code sent',
    msgSmsFail: 'Failed to send code',
    msgNameRequired: 'Please enter a plan name',
    msgPriceRequired: 'Please enter the price',
    msgPriceZero: 'Price cannot be zero',
    titleTip: 'Notice',
    btnOk: 'OK',
    confirmModify: 'Save changes to this plan?',
    confirmAdd: 'Create this plan?',
    msgOpOk: 'Saved',
    msgOpFail: 'Operation failed',
    confirmBindWaters: 'Assign {count} meter(s) to this plan?',
    msgBindOk: 'Assigned',
    msgBindFail: 'Assign failed',
    msgSelectWaters: 'Select at least one meter',
    msgSelectNewWaters: 'Select meters that are not already assigned',
    msgMeterListFail: 'Failed to load meters'
  }
}
